import React, { memo, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Button,
  Typography
} from 'antd';
import {
  MenuOutlined,
} from '@ant-design/icons';
import { useSidebar } from '../../../hooks/useSidebar';
import './Header.css';

const { Title } = Typography;

const Header = memo(() => {
  const { toggleSidebar } = useSidebar();
  const location = useLocation();

  const handleMenuClick = useCallback((e) => {
    toggleSidebar();
    e.currentTarget.blur();
  }, [toggleSidebar]);

  if (location.pathname === '/profile' || location.pathname === '/calendar' || location.pathname === '/income') {
    return (
      <div className="header-mobile">
        <div className="header-mobile__menu-container">
          <Button
            type="text"
            icon={<MenuOutlined />}
            size="small"
            className="header-mobile__menu-button"
            onClick={handleMenuClick}
          />
        </div>

        {/* Center - Title */}
        <Title
          level={4}
          className="header-mobile__title"
        >
          {location.pathname === '/profile' ? 'Profile' : 
           location.pathname === '/income' ? 'Income' : 
           location.pathname === '/calendar' ? 'Calendar' : 'Teacher Web'}
        </Title>

        {/* Right side - Notification icon can be added here if needed */}
      </div>
    );
  }
});

Header.displayName = 'Header';

export default Header;